import React from 'react'
import './Termscondition.scss';

function Termscondition() {
  return (
   <>
    <div className="privacy-parent parent">
      <div className="privacy-cont container">
        <h1>Terms of Service</h1>
        <p>Effective Date: 30 Aug 2024</p>
        
        <p>
          1.1 User Responsibilities: You agree to use our website for lawful
          purposes only and under these Terms. We want you to know that you are
          responsible for any activity under your account and for maintaining
          the confidentiality of your account credentials.
        </p>
        <p>
          1.2 Prohibited Activities: You may not use our website to: Violate any
          applicable laws or regulations. Transmit harmful, fraudulent, or
          malicious content. Engage in unauthorised access, interference, or
          disruption of our website or services. Impersonate any person or
          entity or falsely state or misrepresent your affiliation with any
          person or entity.
        </p>

        <h4>2. Intellectual Property</h4>
        <p>
        2.1 Ownership: All content and materials on our website, including text, graphics, logos, and software, are the property of DIwise India or its licensors and are protected by intellectual property laws. You may not use, reproduce, or distribute any content from our website without prior written consent.
        </p>
        <p>2.2 User Content: By submitting any content to our website, you grant us a non-exclusive, royalty-free, perpetual, and worldwide license to use, modify, reproduce, and distribute such content in connection with our website and services.</p>

        <h4> 3. Third-Party Links</h4>
        <p>
        Our website may contain links to third-party websites or services not owned or controlled by DIwise India. We do not endorse or assume any responsibility for any third-party sites or services. You access third-party websites at risk and should review their terms and privacy policies.
        </p>

        <h4>
        4. Disclaimers and Limitation of Liability</h4>
        <p>
        4.1 Disclaimers: Our website and services are provided "as is" and "as available" without express or implied warranties. We don't think our website will be error-free, secure, or uninterrupted.
        </p>
        <p>4.2 Limitation of Liability: To the fullest extent permitted by Law, DIwise India shall not be liable for any indirect, incidental, special, or consequential damages arising from or in connection with your use of our website or services. Our total liability for any claims under these Terms should not exceed the amount you paid for accessing our website or using our services.</p>

        <h4>5. Indemnification</h4>
        <p>
        You agree to indemnify and hold harmless DIwise India, its affiliates, and their respective officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising out of or related to your use of our website or services, violation of these Terms, or infringement of any rights of a third party.
        </p>

        <h4>6. Modifications to the Terms</h4>
        <p>
        We may update or modify these Terms from time to time. Any changes we make will be posted on this page; your continued use of our website after any changes constitutes your acceptance of the updated Terms. We'd like to encourage you to review these Terms periodically.
        </p>

        <h4>7. Termination</h4>
        <p>
        We reserve the right to terminate or suspend your access to our website and services without prior notice for any reason, including if we believe you have violated these Terms or engaged in conduct harmful to us or other users.
        </p>

        <h4>8. Governing Law</h4>
        <p>
        These Terms are governed by and construed under the laws of Dubai, UAE. Any disputes that arise from or related to these Terms or your use of our website will be resolved in the courts of Dubai, UAE.
        </p>
        <h4>9. Contact Us</h4>
        <p>If you have any questions or concerns about these Terms, please contact us at: info@diwise.in</p>

      </div>
    </div>
   
   </>
  )
}

export default Termscondition